import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=21d3d60e&scoped=true&"
import script from "./HeaderLogo.vue?vue&type=script&lang=js&"
export * from "./HeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLogo.vue?vue&type=style&index=0&id=21d3d60e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d3d60e",
  null
  
)

export default component.exports